import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b383aa8d51a30014074aa1/cglogistica/src/app/not-found.tsx");
